import { Button, ButtonProps } from "@mui/material"
import "./i-button.component.scss"

interface IButtonProps extends ButtonProps {
    label: string,
    onActionEvent?: any,
    variant?: any,
    btnIcon?: any
}

const IButton = (props: IButtonProps) => {
    const variant = props.variant ? props.variant: "contained"

    const onActionEvent = () => {
        if (props.onActionEvent) {
            props.onActionEvent();
        }
    }
    return <Button className="i-button" variant={variant} sx={{ textTransform: 'none' }} {...props} onClick={onActionEvent}
    startIcon={props.btnIcon}>{props.label}</Button>
}

export default IButton;